var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_598_177",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.268066,
    y: 0.463379,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_598_177)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2681 17.1941C12.4969 17.1941 12.6887 17.1167 12.8436 16.9619C12.9984 16.807 13.0758 16.6152 13.0758 16.3864C13.0758 16.1575 12.9984 15.9657 12.8436 15.8109C12.6887 15.6562 12.4969 15.5789 12.2681 15.5789C12.0392 15.5789 11.8474 15.6562 11.6926 15.8109C11.5377 15.9657 11.4603 16.1575 11.4603 16.3864C11.4603 16.6152 11.5377 16.807 11.6926 16.9619C11.8474 17.1167 12.0392 17.1941 12.2681 17.1941ZM11.5181 13.5404H13.0181V7.54038H11.5181V13.5404ZM12.2698 21.9634C10.9558 21.9634 9.72073 21.714 8.56457 21.2154C7.4084 20.7167 6.40273 20.04 5.54757 19.1851C4.6924 18.3303 4.01532 17.325 3.51632 16.1694C3.01748 15.0137 2.76807 13.779 2.76807 12.4651C2.76807 11.1511 3.0174 9.91605 3.51607 8.75988C4.01473 7.60371 4.69148 6.59805 5.54632 5.74288C6.40115 4.88771 7.4064 4.21063 8.56207 3.71163C9.71773 3.2128 10.9525 2.96338 12.2663 2.96338C13.5803 2.96338 14.8154 3.21271 15.9716 3.71138C17.1277 4.21005 18.1334 4.8868 18.9886 5.74163C19.8437 6.59646 20.5208 7.60171 21.0198 8.75738C21.5187 9.91305 21.7681 11.1478 21.7681 12.4616C21.7681 13.7756 21.5187 15.0107 21.0201 16.1669C20.5214 17.323 19.8446 18.3287 18.9898 19.1839C18.135 20.039 17.1297 20.7161 15.9741 21.2151C14.8184 21.714 13.5836 21.9634 12.2698 21.9634ZM12.2681 20.4634C14.5014 20.4634 16.3931 19.6884 17.9431 18.1384C19.4931 16.5884 20.2681 14.6967 20.2681 12.4634C20.2681 10.23 19.4931 8.33838 17.9431 6.78838C16.3931 5.23838 14.5014 4.46338 12.2681 4.46338C10.0347 4.46338 8.14307 5.23838 6.59307 6.78838C5.04307 8.33838 4.26807 10.23 4.26807 12.4634C4.26807 14.6967 5.04307 16.5884 6.59307 18.1384C8.14307 19.6884 10.0347 20.4634 12.2681 20.4634Z",
    fill: "#FF0000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.544d96f527d3dca229fb0ddec400d422.svg";
export { ForwardRef as ReactComponent };